define('captcha/captcha',['require','Config','SBCaptcha'],function (require) {

    'use strict';

    var Config    = require('Config');
    var SBCaptcha = require('SBCaptcha');

    /**
     * Thin AMD wrapper over SBCaptcha for user_public Marionette themes.
     * Fetches /v2/captcha/challenge, passes data to SBCaptcha, bridges jQuery Deferred ↔ native Promise.
     *
     * Module-level singleton: the widget survives view re-renders and DetailsStep recreation.
     * When the container changes (e.g. user navigated back then forward):
     *   - already verified: reuse existing token, no re-render needed.
     *   - not yet verified: reset widget and re-fetch challenge into the new container.
     */
    var _widget      = null;
    var _ready       = false;
    var _initializing = false;
    var _containerEl = null;

    var Captcha = function () {};

    Captcha.prototype = {

        /**
         * @param {Element} containerEl
         * @return {$.Deferred}
         */
        init: function (containerEl) {
            var deferred = $.Deferred();
            var captchaConfig = Config.getInstance().getOption('captcha');

            if (!captchaConfig || !captchaConfig.enabled) {
                deferred.resolve();
                return deferred.promise();
            }

            if (_widget) {
                if (containerEl !== _containerEl) {
                    _containerEl = containerEl;
                    if (_widget.canReuseToken()) {
                        // Reusable token already obtained — no need to re-render
                        deferred.resolve();
                        return deferred.promise();
                    }
                    // Widget not yet verified — reset and re-render into new container
                    _widget.reset();
                    _widget        = null;
                    _ready         = false;
                    _initializing  = false;
                    // Fall through to re-fetch challenge and re-render
                } else {
                    deferred.resolve();
                    return deferred.promise();
                }
            }

            _containerEl = containerEl;

            if (_initializing) {
                deferred.resolve();
                return deferred.promise();
            }

            _initializing = true;

            $.get('/v2/captcha/challenge').then(function (data) {
                _widget       = new SBCaptcha({ container: _containerEl, challenge: data });
                _ready        = true;
                _initializing = false;
                deferred.resolve();
            }).fail(function () {
                _initializing = false;
                deferred.resolve();
            });

            return deferred.promise();
        },

        /**
         * @return {$.Deferred}  resolves with token string or null
         */
        getToken: function () {
            var deferred = $.Deferred();
            if (!_ready || !_widget) {
                deferred.resolve(null);
                return deferred.promise();
            }
            _widget.getToken().then(function (token) {
                deferred.resolve(token);
            });
            return deferred.promise();
        },

        /**
         * @return {boolean}  true if the user has completed captcha verification
         */
        isVerified: function () {
            if (!_ready || !_widget) { return false; }
            return _widget.isVerified();
        },

        /**
         * Re-fetches a fresh challenge and re-renders the widget.
         * Call after a failed booking attempt so the token can be reused.
         */
        refresh: function () {
            if (!_containerEl) { return; }
            if (_widget) { _widget.reset(); _widget = null; }
            _ready        = false;
            _initializing = false;
            this.init(_containerEl);
        },

        /**
         * Clears widget state after a successful booking so the next "Book more"
         * flow starts with a fresh challenge instead of reusing the consumed token.
         */
        resetForNewBooking: function () {
            if (_widget) { _widget.reset(); _widget = null; }
            _ready        = false;
            _initializing = false;
            _containerEl  = null;
        },

    };

    return Captcha;

});

